import React from "react";
import Chart from "react-apexcharts";
import { CallIcon } from "../../assets/Icons";
import { withRouter } from "react-router-dom";
import TableSkelton from "../../skeltonloader/TableSkelton";

class DashboardChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: new Date().getFullYear(),
      chartLoading: false,
      series: [
        {
          name: "Calls made",
          data: [],
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        colors: ["#2f3a79"],
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val * 1;
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },

        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          position: "bottom",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val * 1;
            },
          },
        },
        title: {
          text: "",
          floating: true,
          offsetY: 330,
          // offsetX: 330,
          align: "center",
          style: {
            color: "#444",
          },
        },
      },
    };
  }

  componentWillReceiveProps(props) {
    this.state.series[0].data = props.call_barChartData;
    this.setState(this.state);
  }

  ReportsView = (list) => {
    sessionStorage.setItem("report_info_workflow", JSON.stringify(list));
    // window.location.href = "/create/reportworkflow"
    // window.location.href = "/create/alignedworkflowsession";
    this.props.history.push("/create/alignedworkflowsession");
  };
  showCallerDetails = (list) => {
    sessionStorage.setItem("call_staistics", JSON.stringify(list));
    // window.location.href = "/create/callstaistics";
    this.props.history.push("/create/callstaistics");
  };
  // onChangeInputDropDown = (e) => {
  //   this.props.changeYear(Number(e.target.value));
  //   this.state.series[0].data = [];
  //   this.state.selectedYear = Number(e.target.value);
  //   this.setState(this.state);
  // };
  onChangeInputDropDown = (e) => {
    const selectedYear = Number(e.target.value);
    this.setState({
      selectedYear,
      chartLoading: true,
      series: [{ ...this.state.series[0], data: [] }],
    });
    this.props.changeYear(selectedYear);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.call_barChartData !== this.props.call_barChartData) {
      this.setState({
        series: [{ ...this.state.series[0], data: this.props.call_barChartData }],
        chartLoading: false,
      });
    }
  }

  render() {
    const { loading } = this.props;
    return (
      <div>
        <div className="row calldashboard mt-4">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="card border-radius-top-20">
              <div className="card-header">
                <h4>
                  <CallIcon /> Call Dashboard
                </h4>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <div className="xp-chart-label">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="calldash document_gradient_border py-4">
                            <h5 className="pt-3">Total calls</h5>

                            <span className="text-dark mb-3 pb-3">
                              {loading ? (
                                <div
                                  className="skeleton mx-auto d-block mt-3"
                                  style={{ height: "1.5rem", width: "4rem" }}
                                />
                              ) : (
                                <>
                                  {/* <CallIcon /> {this.props.call_info ? this.props.call_info.total : 0} */}
                                  <CallIcon /> {this.props.total_callLogs}
                                </>
                              )}
                            </span>
                            {/* )} */}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="calldash document_gradient_border">
                            <h5 className="pt-3">Total Call Duration</h5>
                            <span className="text-success mb-3 pb-3">
                              {loading ? (
                                <div
                                  className="skeleton mx-auto d-block mt-3"
                                  style={{ height: "1.5rem", width: "4rem" }}
                                />
                              ) : (
                                <>
                                  <CallIcon /> {this.props.call_info ? this.props.call_info.total_call_duration : 0}
                                </>
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="calldash document_gradient_border py-4">
                            <h5 className="pt-3">Unique Callers</h5>
                            <span className="text-primary mb-3 pb-3">
                              {loading ? (
                                <div
                                  className="skeleton mx-auto d-block mt-3"
                                  style={{ height: "1.5rem", width: "4rem" }}
                                />
                              ) : (
                                <>
                                  <CallIcon /> {this.props.call_logs.length}
                                </>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid_2 g_4_6">
                      <div className="card call-statistics-table document_gradient_border padding-0 ">
                        <div className="card-header border-radius-top-15">
                          <h4>Outgoing Calls Statistics</h4>
                        </div>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Outgoing Calls</th>
                                  <th className="text-center" style={{ width: "130px" }}>
                                    All Logs
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <TableSkelton rowCount={3} colCount={3} />
                                ) : (
                                  this.props.call_logs.map((list, index) => (
                                    <tr>
                                      <td>{list.name}</td>
                                      <td>{list.total}</td>
                                      <td className="text-center">
                                        <div
                                          className="tabledit-toolbar btn-toolbar"
                                          style={{ margin: "0 auto", display: "block" }}
                                        >
                                          <div className="btn-group btn-group-sm">
                                            <button
                                              type="button"
                                              onClick={() => this.showCallerDetails(list)}
                                              className="btn text-blue"
                                            >
                                              Details
                                            </button>
                                            {/* <button type="button" className="btn btn-sm btn-primary">Delete </button> */}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="card document_gradient_border padding-0">
                        <div className="card-header border-radius-top-15">
                          <h4>Successful Calls</h4>
                        </div>
                        <div className="card-body">
                          <div className="form-row">
                            <div className="form-group col-md-6">
                              {/* <label for="exampleInputEmail1">Select Workflow Type</label> */}

                              <div className="w-50">
                                {loading ? (
                                  <div className="skeleton" style={{ height: "2rem", width: "5rem" }} />
                                ) : (
                                  <select
                                    name="sop"
                                    className="form-control"
                                    onChange={this.onChangeInputDropDown}
                                    value={this.state.selectedYear}
                                  >
                                    {this.props.Years.map((list, index) => {
                                      return (
                                        <option key={index} value={list}>
                                          {list}
                                        </option>
                                      );
                                    })}
                                  </select>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* {loading ? (
                            <div className="skeleton" style={{ height: "15rem", width: "100%" }} />
                          ) : (
                            <div id="chart">
                              {this.state.series[0].data.length == 0 ? null : (
                                <Chart
                                  options={this.state.options}
                                  series={this.state.series}
                                  type="bar"
                                  height={350}
                                />
                              )}
                            </div>
                          )} */}
                          {this.state.chartLoading ? (
                            <div className="skeleton" style={{ height: "350px", width: "100%" }} />
                          ) : (
                            <div id="chart">
                              {this.state.series[0].data.length === 0 ? null : (
                                <Chart
                                  options={this.state.options}
                                  series={this.state.series}
                                  type="bar"
                                  height={350}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="grid_2">
                      <div className="card document_gradient_border padding-0">
                        <div className="card-header border-radius-top-15">
                          <h4> Workflow</h4>
                        </div>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th style={{ width: "70px" }}>S.No</th>
                                  <th>Workflow Name</th>
                                  <th style={{ width: "250px" }}>Published On</th>
                                  <th style={{ width: "100px" }}>On Going</th>
                                  <th style={{ width: "100px" }}>Completed</th>
                                  <th style={{ width: "200px", textAlign: "center" }}>Session</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <TableSkelton rowCount={3} colCount={6} />
                                ) : this.props.WorkflowList != undefined ? (
                                  this.props.WorkflowList.map((list, index) => (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{list.workflow_name}</td>
                                      <td>{list.workflow_publishdate}</td>
                                      <td className="text-center">
                                        <span>
                                          <strong>
                                            {list.workflow_total_ongoing == null ? 0 : list.workflow_total_ongoing}{" "}
                                          </strong>
                                        </span>
                                      </td>
                                      <td className="text-center">
                                        <span>
                                          <strong>
                                            {list.workflow_total_completed == null ? 0 : list.workflow_total_completed}{" "}
                                          </strong>
                                        </span>
                                      </td>

                                      <td className="text-center">
                                        <div
                                          className="tabledit-toolbar btn-toolbar"
                                          style={{ margin: "0 auto", display: "block" }}
                                        >
                                          <div className="btn-group btn-group-sm">
                                            <button
                                              type="button"
                                              onClick={() => this.ReportsView(list)}
                                              className="btn text-blue"
                                            >
                                              See Session
                                            </button>
                                            {/* <button type="button" className="btn btn-sm btn-primary">Delete </button> */}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(DashboardChart);
